import store from '@/stores/store';

export default (to, from, next) => {

    if (store.getters['authStore/authenticated']) {
        next({ name: '/' })
    }
    
}